import { useMemo, useState } from 'react';

export const useOrdering = <T extends Record<string, any>>(
    item: T[],
    defaultSortKey: string,
    initialOrderForDefaultKey: 'asc' | 'desc' = 'asc'
) => {
    const [orderMap, setOrderMap] = useState<Record<string, 'asc' | 'desc'>>({
        [defaultSortKey]: initialOrderForDefaultKey
    });
    const [orderBy, setOrderBy] = useState<string>(defaultSortKey);

    const handleRequestSort = (property: string) => {
        const currentOrder = orderMap[property] || 'asc';
        const newOrder = currentOrder === 'asc' ? 'desc' : 'asc';
        setOrderMap((prev) => ({ ...prev, [property]: newOrder }));
        setOrderBy(property);
    };

    const order = orderMap[orderBy] || 'asc';

    const orderedItems = useMemo(() => {
        return [...item].sort((a, b) => {
            if (a[orderBy] < b[orderBy]) {
                return order === 'asc' ? -1 : 1;
            }
            if (a[orderBy] > b[orderBy]) {
                return order === 'asc' ? 1 : -1;
            }
            return 0;
        });
    }, [item, orderBy, order]);

    return {
        order,
        orderBy,
        handleRequestSort,
        orderedItems,
        orderMap
    };
};
